export interface CheckoutAuthResponse {
  externalApiToken: string;
}
